module.exports = __webpack_public_path__ + "img/02_no.de90634c.svg";